import _extends from "@babel/runtime-corejs3/helpers/extends";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import Button from '../button';
import Icon from '../icon';
import Upload from '../upload';
import devWarning from '../_utils/devwarning';
var ImageFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
var OperationBar = function OperationBar(props) {
  var className = props.className,
    btnClassName = props.btnClassName,
    customComponents = props.customComponents,
    _props$imageMaxSize = props.imageMaxSize,
    imageMaxSize = _props$imageMaxSize === void 0 ? 2 : _props$imageMaxSize,
    okText = props.okText,
    okBtn = props.okBtn,
    _props$showDeaultTool = props.showDeaultToolbar,
    showDeaultToolbar = _props$showDeaultTool === void 0 ? true : _props$showDeaultTool,
    getCropper = props.getCropper,
    onClick = props.onClick,
    onRevert = props.onRevert,
    onRotate = props.onRotate,
    onZoom = props.onZoom,
    onReplace = props.onReplace;
  var handleBtnClick = function handleBtnClick() {
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  var handleRotate = function handleRotate() {
    onRotate === null || onRotate === void 0 ? void 0 : onRotate();
  };
  var handleRevert = function handleRevert() {
    onRevert === null || onRevert === void 0 ? void 0 : onRevert();
  };
  var handleZoom = function handleZoom(value) {
    onZoom === null || onZoom === void 0 ? void 0 : onZoom(value);
  };
  var beforeUpload = useCallback(function (file) {
    var isImg = _includesInstanceProperty(ImageFileTypes).call(ImageFileTypes, file.type);
    if (!isImg) {
      devWarning(true, 'image-cropper', 'You can only upload JPG/PNG file!');
    }
    var sizeOk = file.size <= 1024 * 1024 * imageMaxSize;
    if (!sizeOk) {
      devWarning(true, 'image-cropper', "Please upload a picture smaller than ".concat(imageMaxSize, " MB."));
    }
    if (isImg && sizeOk) {
      var src = _URL.createObjectURL(file);
      onReplace === null || onReplace === void 0 ? void 0 : onReplace(src);
    }
    return false;
  }, [onReplace, imageMaxSize]);
  var accept = useMemo(function () {
    return _mapInstanceProperty(ImageFileTypes).call(ImageFileTypes, function (type) {
      return ".".concat(type.replace('image/', ''));
    }).join(',');
  }, []);
  var uploadProps = useMemo(function () {
    return {
      accept: accept,
      beforeUpload: beforeUpload,
      showUploadList: false
    };
  }, [accept, beforeUpload]);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, showDeaultToolbar && /*#__PURE__*/React.createElement("div", {
    className: classNames(btnClassName)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "reduction",
    onClick: handleRevert
  }), /*#__PURE__*/React.createElement(Upload, _extends({}, uploadProps), /*#__PURE__*/React.createElement(Icon, {
    type: "upload"
  })), /*#__PURE__*/React.createElement(Icon, {
    type: "spin",
    onClick: handleRotate
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "reduce",
    onClick: function onClick() {
      return handleZoom(-0.1);
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "add",
    onClick: function onClick() {
      return handleZoom(0.1);
    }
  })), customComponents && _mapInstanceProperty(customComponents).call(customComponents, function (Component, index) {
    return Component(getCropper, index);
  }), okBtn ? /*#__PURE__*/React.createElement("div", {
    onClick: handleBtnClick
  }, okBtn) : /*#__PURE__*/React.createElement(Button, {
    className: classNames('ok-btn'),
    type: "primary",
    onClick: handleBtnClick
  }, okText));
};
export default OperationBar;